import _ from 'lodash'
import { FormFeedback, Input, Label, UncontrolledTooltip } from 'reactstrap'

const InputText = (props) => {
    const { id, label, className = '', formik, isRequired = false, isDisabled, type, rows, permission } = props
    const { values, errors, touched, handleChange, handleBlur } = formik ?? {}

    const value = _.get(values, id)
    const error = _.get(errors, id)
    const isTouched = _.get(touched, id)

    return (
        <div className={className}>
            <Label htmlFor={id}>{label}</Label>
            {isRequired && <span className="required-mark">*</span>}
            {permission && (
                <>
                    {' '}
                    <span id={`agentPermissionsTooltip${permission.id}`}>
                        <i className="mdi mdi-help-circle-outline"></i>{' '}
                    </span>
                    <UncontrolledTooltip placement="right" target={`agentPermissionsTooltip${permission.id}`}>
                        {permission.description}
                    </UncontrolledTooltip>
                </>
            )}

            <Input
                id={id}
                name={id}
                onChange={handleChange}
                onBlur={handleBlur}
                value={value ?? ''}
                invalid={(error && isTouched) ?? false}
                disabled={isDisabled}
                type={type}
                rows={rows}
            />
            {error && isTouched ? <FormFeedback type="invalid">{error}</FormFeedback> : null}
        </div>
    )
}

export default InputText
